<template>
    <div v-if="isViewOnly" v-html="nl2br(value)"></div>
    <textarea v-else :value="value" v-on:input="onTextChanged" style="box-sizing: border-box;"></textarea>
</template>

<script>
    export default {
        name: 'rich-text-area',
        props: {
            value: String,
            isViewOnly: Boolean
        },
        data() {
            return {
                text: this.value
            };
        },
        methods: {
            nl2br(str){
                if (typeof str === 'undefined' || str === null) {
                    return '';
                }
                var breakTag = '<br />';
                return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
            },
            onTextChanged(event){
                this.$emit('input', event.target.value)
            }
        },
        watch:{
        },
    }
</script>
